<template>
    <form-radio-list 
        :id="id" 
        :label="label" 
        :validationFieldLabel="validationFieldLabel" 
        :validationInvalidFeedback="validationInvalidFeedback"
        :values="values"
        v-model="selected">
    </form-radio-list>
</template>
<script>
import FormRadioList from '@/components/FormRadioList.vue'
export default {
    props: {
        value: { required: true },
        id: { required: true },
        label: { required: true },
        validationFieldLabel: {required:true},
        validationInvalidFeedback: {required:true}
    },
    components: {
        FormRadioList
    },
    data: () => {
        return {
            selected: null
        }
    },
    mounted() {
        this.selected = this.value
    },
    computed: {
        values() {
            return [
                {
                    id: this.id + '__Yes',
                    name: this.id,
                    label: 'Yes',
                    value: true
                },
                {
                    id: this.id + '__No',
                    name: this.id,
                    label: 'No',
                    value: false
                }
            ]
        }
    },
    watch:{
        selected(newVal) {
            this.$emit('input', this.selected);
        }
    }
}
</script>